import { Pill } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { estadosSds } from '../../utils/dataStatus';
import { proveedorNotificador, proveedorAdministrador } from '../../security/constantsRols';
import { checkRol } from '../../security';
import './PillStatus.scss';

const getLabelStateRol = (statePendients, rolsProvider) =>
  statePendients?.estado === 'Enviada' && rolsProvider ? 'Recibida' : 'Enviada';

const getMessagesAndChecks = (accepted, reject, totally, rolsProvider) => {
  const messageAccepted = accepted > 0 ? `Aceptó: ${accepted}` : '';
  const messageRejection = reject > 0 ? `Rechazó: ${reject}` : '';
  const noAnswer = totally - (accepted + reject);
  const messageNoAnswer = noAnswer > 0 ? `No contestó: ${noAnswer}` : '';
  const acceptedChecks = rolsProvider && accepted ? 'accepted' : '';
  const rejectChecks = rolsProvider && reject ? 'rejected' : '';

  return { messageAccepted, messageRejection, messageNoAnswer, acceptedChecks, rejectChecks };
};

const PillStatus = ({ accepted, responsetotally, totally, pastTime, idStatus, reject }) => {
  const statePendients = estadosSds.find((state) => state.id === idStatus);
  const rolsProvider = checkRol(proveedorNotificador) || checkRol(proveedorAdministrador);

  const labelStateRol = getLabelStateRol(statePendients, rolsProvider);
  const { messageAccepted, messageRejection, messageNoAnswer, acceptedChecks, rejectChecks } =
    getMessagesAndChecks(accepted, reject, totally, rolsProvider);

  const renderTooltip = (propsTooltip) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Tooltip id="button-floating-tooltip" {...propsTooltip}>
      <div> {`${messageAccepted} ${messageRejection} ${messageNoAnswer}`} </div>
    </Tooltip>
  );

  if (statePendients?.estado === 'Enviada') {
    return (
      <OverlayTrigger
        delay={{
          show: 250,
          hide: 400
        }}
        overlay={!rolsProvider ? renderTooltip() : <></>}
        placement="left"
      >
        <div>
          <Pill
            asAccepted={acceptedChecks || rejectChecks}
            className="pill"
            label={rolsProvider ? labelStateRol : `${labelStateRol} ${accepted}/${totally}`}
            textColour={responsetotally ? 'light' : 'info'}
            time={pastTime}
            variant={responsetotally ? 'info' : 'light'}
          />
        </div>
      </OverlayTrigger>
    );
  }

  return (
    <Pill
      label={statePendients?.estado}
      textColour={statePendients?.textColour}
      variant={statePendients?.color}
    />
  );
};

export default PillStatus;

PillStatus.propTypes = {
  accepted: PropTypes.number,
  responsetotally: PropTypes.bool,
  totally: PropTypes.number,
  pastTime: PropTypes.bool,
  idStatus: PropTypes.number,
  reject: PropTypes.number,
  tooltip: PropTypes.bool
};

PillStatus.defaultProps = {
  accepted: 0,
  responsetotally: false,
  totally: 0,
  pastTime: false,
  idStatus: 0,
  reject: 0,
  tooltip: true
};
